// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8273) return "static/chunks/8273-7d055722837414df.js";
	if (chunkId === 7718) return "static/chunks/7718-321cf223f9621870.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3496":"graphql-print","5447":"d39b6ced"}[chunkId] || chunkId) + "." + {"3496":"7ef39872c8b54dd4","5447":"8f3f25248b1b198f","9432":"b1d02e4f75f86580"}[chunkId] + ".js";
};